import { cls } from "@/utils/util";
import WingBanner from "./Ads";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const WingBannerWrapper = ({ scrolled }: { scrolled: boolean }) => {
  const location = useLocation();

  const isShowHeaderWingBanner = useMemo(() => {
    const locationPath = location.pathname.split("/")[1];
    return !["market", "shurink", "hermannryff", "ray", "signup"].includes(locationPath);
  }, [location.pathname]);

  if (!isShowHeaderWingBanner) return null;

  return (
    <div className="w-[1200px] absolute left-1/2 -translate-x-1/2">
      <div
        className={cls(
          scrolled ? "top-[56px]" : "top-[170px]",
          "hidden 2xl:flex 2xl:flex-col gap-[12px] w-[120px] absolute left-[-140px]",
        )}
      >
        <WingBanner name="pc_all_wing_left_top" />
        <WingBanner name="pc_all_wing_left_middle" />
        <WingBanner name="pc_all_wing_left_bottom" />
      </div>
      <div
        className={cls(
          "2xl:flex hidden",
          "absolute flex flex-col gap-[12px] w-[120px]",
          scrolled ? "top-[56px] right-[-140px]" : "top-[170px] right-[-140px]",
        )}
      >
        <WingBanner name="pc_all_wing_right_top" />
        <WingBanner name="pc_all_wing_right_middle" />
        <WingBanner name="pc_all_wing_right_bottom" />
      </div>
    </div>
  );
};

export default WingBannerWrapper;
